/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('Recipient', function($scope, recipientService, $stateParams, $rootScope,
    _$breadcrumbs, _$editmode, _$privileges) {

    _$editmode.turnOff();

    $scope.row;
    $scope.id = $stateParams.id;
    $scope.data = {
        "can_write": false,
        "reset_method": "",
        "teamSupported": false,
        "subunitSupported": false,
        "activeNotifications": []
    };

    $scope.delete = function() {
        var promise = recipientService.delete($scope.id);
        promise.then(
            function(payload) {
                if (payload.data.code) {
                    $rootScope.notification.showAfterRedirect('recipients', {}, 'success', payload.data.msg);
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Wystąpił błąd podczas próby usunięcia odbiorcy');
            });
    };

    $scope.renewMobileCode = function() {
        if ($scope.row.data.phone == "" && $scope.row.data.email == "" && $scope.row.data.epuap) {
            $rootScope.notification.show('error', 'Odbiorca nie posiada danych kontaktowych');
        } else {
            var promise = recipientService.renewMobileCode($scope.id);
            promise.then(
                function(payload) {
                    if (payload.data.code) {
                        $scope.row.mobile_verification_code = payload.data.newcode;
                        $rootScope.notification.show('success', payload.data.msg);
                    } else {
                        $rootScope.notification.show('error', payload.data.msg);
                    }
                },
                function(errorPayload) {
                    $rootScope.notification.show('error', 'Wystąpił błąd podczas próby resetowania kodu walidacyjnego');
                });
        }
    };

    $scope.init = function() {
        $scope.data.can_write = _$privileges.write("receiver");

        var promise = recipientService.show($scope.id);
        promise.then(
            function(payload) {
                $scope.data.activeNotifications = payload.data.activeNotifications;
                if (payload.data.row.length == 0) {
                    $rootScope.notification.showAfterRedirect('recipients', {}, 'error', 'Podany odbiorca nie został odnaleziony');
                } else {
                    $scope.data.subunitSupported = payload.data.subunitSupported;
                    $scope.data.teamSupported = payload.data.teamSupported;

                    $scope.row = payload.data.row;
                    if ($scope.row.data.phone != "")
                        $scope.data.reset_method = "numer telefonu";
                    else if ($scope.row.data.email != "")
                        $scope.data.reset_method = "adres e-mail";
                    else if ($scope.row.data.epuap)
                        $scope.data.reset_method = "kontakt epuap";
                    _$breadcrumbs.push($scope.row.data.name + ' ' + $scope.row.data.surname);
                }
            },
            function(errorPayload) {
                $rootScope.notification.showAfterRedirect('recipients', {}, 'error', 'Błąd wyświetlania odbiorcy');
            });
    };

    $scope.print = function(id) {
        var promise = recipientService.printpdf(id);
        promise.then(
            function(payload) {
                if (payload.data == "")
                    $rootScope.notification.show(0, "Nie udało się wygenerować pliku wydruku");
                else {
                    top.location.href = "/downloadpdf/" + payload.data;
                }
            });
    };

    $scope.init();
});
